var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useAuthStore } from "../../application/stores/auth.store";
import { getProfile, getProfileWithoutAuthToken } from "../../application/usecases/getCompanyInfoV2";
import { changeColorStyle, changeFontType } from '../../utils/formSpecificsUtils';
const UserProfileContext = createContext(undefined);
export const UserProfileProvider = ({ children }) => {
    const [userProfile, setUserProfile] = useState(null);
    const [isLoadingUserProfileContext, setIsLoadingUserProfileContext] = useState(false);
    const [collectivePersonalization, setCollectivePersonalization] = useState(null);
    const [isPersonalizationApiCalled, setIsPersonalizationApiCalled] = useState(false);
    const companyId = useAuthStore((state) => state.getCompanyId());
    const { isAuthenticated } = useAuthStore();
    const getLogo = () => collectivePersonalization === null || collectivePersonalization === void 0 ? void 0 : collectivePersonalization.logoUrl;
    const getPersonalization = () => collectivePersonalization;
    const getCheckPersonalizationApiCalled = () => isPersonalizationApiCalled;
    const fetchProfile = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        if (!companyId || isNaN(companyId)) {
            console.error("El companyId no es válido");
            return;
        }
        setIsLoadingUserProfileContext(true);
        try {
            const result = yield getProfile(companyId);
            setUserProfile(result);
            setCollectivePersonalization(result.collectivePersonalization);
            if ((_a = result === null || result === void 0 ? void 0 : result.collectivePersonalization) === null || _a === void 0 ? void 0 : _a.colors) {
                changeColorStyle(result.collectivePersonalization.colors);
            }
            if ((_b = result === null || result === void 0 ? void 0 : result.collectivePersonalization) === null || _b === void 0 ? void 0 : _b.fonts) {
                changeFontType(result.collectivePersonalization.fonts);
            }
        }
        catch (error) {
            console.error("Error al obtener datos:", error);
            setUserProfile(null);
        }
        finally {
            setIsLoadingUserProfileContext(false);
        }
    });
    const fetchProfileWithoutUserToken = (companyIdParam) => __awaiter(void 0, void 0, void 0, function* () {
        var _c, _d;
        const idToUse = companyIdParam ? Number(companyIdParam) : companyId;
        if (!idToUse || isNaN(idToUse)) {
            console.error("El companyId no es válido");
            return;
        }
        setIsLoadingUserProfileContext(true);
        try {
            const result = yield getProfileWithoutAuthToken(idToUse);
            setUserProfile(result);
            setCollectivePersonalization(result.collectivePersonalization);
            if ((_c = result === null || result === void 0 ? void 0 : result.collectivePersonalization) === null || _c === void 0 ? void 0 : _c.colors) {
                changeColorStyle(result.collectivePersonalization.colors);
            }
            if ((_d = result === null || result === void 0 ? void 0 : result.collectivePersonalization) === null || _d === void 0 ? void 0 : _d.fonts) {
                changeFontType(result.collectivePersonalization.fonts);
            }
        }
        catch (error) {
            console.error("Error al obtener datos:", error);
            setUserProfile(null);
        }
        finally {
            setIsLoadingUserProfileContext(false);
        }
    });
    useEffect(() => {
        if (isAuthenticated) {
            setUserProfile(null);
            setCollectivePersonalization(null);
            fetchProfile();
        }
    }, [isAuthenticated]);
    const contextValue = useMemo(() => ({
        userProfile,
        isLoadingUserProfileContext,
        fetchProfile,
        fetchProfileWithoutUserToken,
        getLogo,
        getPersonalization,
        getCheckPersonalizationApiCalled
    }), [
        userProfile,
        isLoadingUserProfileContext,
        collectivePersonalization,
        isPersonalizationApiCalled
    ]);
    return (_jsx(UserProfileContext.Provider, Object.assign({ value: contextValue }, { children: children })));
};
export const useUserProfileContext = () => {
    const context = useContext(UserProfileContext);
    if (!context) {
        throw new Error("useUserProfileContext debe usarse dentro de un UserProfileProvider");
    }
    return context;
};
